import fkOrId from '@drivesally/sally-fw/lib/lib/fkOrId';
import isObject from 'is-object';

const normalizeTag = (tag, tagLookup = {}) => {
  if (tag === null || tag === undefined) return null;

  if (typeof tag === 'string') {
    return {id: tag, tag, color: null};
  }

  if (typeof tag === 'number') {
    return tagLookup[tag] || null;
  }

  if (isObject(tag)) {
    const id = fkOrId(tag);
    const label = tag.tag || tag.name || tag.label;

    if (label) {
      return {
        id,
        tag: label,
        color: tag.color || tagLookup[id]?.color || null,
      };
    }

    return tagLookup[id] || null;
  }

  return null;
};

const normalizeTags = (tags, tagLookup = {}) => {
  if (!tags) return [];

  const list = Array.isArray(tags) ? tags : [tags];

  return list
    .map((tag) => normalizeTag(tag, tagLookup))
    .filter((tag) => !!tag?.tag);
};

export default normalizeTags;
